<template>
    <layout-card
        :error="error"
        :loading="loading"
        :type="settings.context"
        :isCustomizable="settings.isCustomizable"
        class="card-proforma_corp"
        @edit-card="toggleSettingsForm"
        @hide-card="$emit('hide-card', type)"
        @refresh-card="fetchCard(type, {}, true)"
    >
        <template #title>
            {{ name }}
        </template>

        <template #content>
            <template-kpi-card :data="{ stats: cardData, labels: labels }" />

            <Teleport to="#dashboardSettingsForm">
                <card-setting-overlay
                    v-if="showSettingsForm"
                    :formName="settingsFormName"
                    :cardCustomSettings="customSettings"
                    :cardName="type"
                    @fetched="fetchCard"
                    @close-form="toggleSettingsForm"
                    @custom-settings-saved="fetchCard(type, {}, true)"
                />
            </Teleport>
        </template>

        <template #footer>
            <fiscal-year-footer :fiscalYearTimestamp="fiscalYear"></fiscal-year-footer>
        </template>
    </layout-card>
</template>

<script>
import LayoutCard from './LayoutCard.vue';
import TemplateKpiCard from './TemplateKpiCard.vue';
import CardMixin from './CardMixin.js';
import FiscalYearFooter from './FiscalYearFooter.vue';

export default {

    components: {
        LayoutCard,
        TemplateKpiCard,
        FiscalYearFooter,
    },
    mixins: [CardMixin],
    data() {
        return {
            labels: {
                accepted: {
                    label: this.$l10n.__('En attente de facturation'),
                    labelCount: this.$l10n.__('Factures'),
                },
                expired: {
                    label: this.$l10n.__('Expiré'),
                    labelCount: this.$l10n.__('Factures'),
                },
            },
            settingsFormName: 'proforma-setting-form',
        };
    },
};
</script>
